<template>
  <el-row>
    <el-col :span="24" >
      <div  class="leftnav" :style="{'height':ileftHeight +'px'}">
        <ul>
          <li v-for="(item,index) in deps" :key="index" :class="selectdep == item.id?'dd-this':''" @click="changedep(item);"><span>{{item.text}}</span><i></i></li>
        </ul>
      </div>
      <div class="main" :style="{'height':ibHeight +'px'}">
        <el-row class="mainbox">
          <el-col :span="24" >
            <el-col :span="24">
              <el-col :span="24">
                <el-form  :inline="true"  :model="where"    class="demo-form-inline searchbox">
                  <el-form-item label="关键词：">
                    <el-input v-model="keyword" @keyup.native.enter="query" prefix-icon="el-icon-search" placeholder="请输入检索内容等查询..."></el-input> 
                  </el-form-item>
                  <el-form-item label="企业：" v-if="selectdep ==1">
                    <el-select v-model="qiyeid" placeholder="请选择" @change="query">
                        <el-option
                        v-for="item in changjialist"
                        :key="item"
                        :label="item.label"
                        :value="item.id">
                        </el-option>
                    </el-select>

                  
                  </el-form-item>
                   <el-form-item  v-if="selectdep ==1">
                     <el-radio-group v-model="radioval" @change="query">
                        <el-radio label="-1" >全部</el-radio>
                        <el-radio label="1">即将到期</el-radio>
                        <el-radio label="2">已过期</el-radio> 
                    </el-radio-group>
                  </el-form-item>
                   <el-form-item >
                  <el-button style="margin-left:10px;" icon="el-icon-search" type="success" @click="query">快速查询</el-button>
                  </el-form-item>
                  </el-form>
              </el-col>
            </el-col>
            <el-col :span="24" style="background:rgba(0,217,255,.15);padding:10px; ">
              <el-row>

                <el-col :span="24" >
                <el-col>
                <el-table
                  :data="tabledata"
                  style="width: 100%"
                  border
                    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
                  >
                  <el-table-column
                   
                    type="index"
                      align="center"
                      label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    
                    prop="Imei"
                    label="设备IMEI"
                    align="center"
                    width="180">
                  </el-table-column>
                  <el-table-column v-if="selectdep ==1"
                 
                    prop="qiye"
                    label="所在企业"
                    width="120">
                  </el-table-column>
                  <el-table-column
                  
                    prop="Weizhi"
                    label="设备所在位置"
                    align="center"
                    width="180">
                  </el-table-column>
                  <el-table-column
                 
                    prop="DeviceName"
                    label="设备名称"
                    
                    min-width="100">
                  </el-table-column>

                  <el-table-column
                 
                    prop="DeviceModel"
                    label="设备型号"
                    
                    min-width="100">
                  </el-table-column>
                  <el-table-column
                 
                    prop="Specs"
                    label="设备规格"
                    
                    min-width="100">
                  </el-table-column>
                  <el-table-column
                  
                    prop="StateDesc"
                    label="状态"
                    align="center"
                    width="80">
                  </el-table-column>
                   
                  <el-table-column v-if="selectdep ==1"
                  
                    prop="PinlvDesc"
                    label="频率"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column v-if="selectdep ==1"
             
                    prop="DaoqiStr"
                    label="到期状态"
                    align="center"
                    width="90">
                  </el-table-column>
                  <el-table-column v-if="selectdep ==1"
             
                    prop="Daoqitime"
                    label="到期日期"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column v-if="selectdep ==1"
                    prop="Fuzeren"
                    label="所属负责人"
                    align="center"
                    width="120">
                  </el-table-column>
                   <el-table-column v-if="selectdep ==1"
                    prop="Fuzerentel"
                    label="所属负责人手机"
                    align="center"
                    width="120">
                  </el-table-column>
                   
                  <el-table-column
               
                label="操作"
                align="center"
                fixed="right"
                width="240"
              >
               <template slot-scope="scope">
                  <el-button  
                    @click="editbtn(scope.row)"
                    type="warning"
                    size="small"
                  >编辑</el-button>
                  <el-button v-if="selectdep ==1"
                    @click="jiebangbtn(scope.row)"
                    type="danger"
                    size="small"
                  >解绑</el-button>

                   <el-button v-if="selectdep ==2"
                    @click="editbtn(scope.row)"
                    type="warning"
                    size="small"
                  >关联</el-button>

                  <el-button  
                    @click="delbtn(scope.row)"
                    type="danger"
                    size="small"
                  >删除</el-button>
                   
                </template>
              </el-table-column>
                </el-table>
                   </el-col>
 <el-col style="margin-top:10px;text-align:center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="limit"
                  :total="total">
                </el-pagination>
              </el-col>
              </el-col>
              </el-row>

            </el-col>
           </el-col>
        </el-row>
      </div>
    </el-col>
  <el-dialog
      title=""
      :visible.sync="editkongzhigFlag"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col
          :span="24"
          class="stoptitle"
        >
          {{editshebeiFrom.EnterpriseId?'编辑设备':'关联设备'}}
        </el-col>
         <el-form
            :model="editshebeiFrom"
            :rules="editshebeiFromRules"
            ref="userForm"
            label-width="100px"
          >
        
        <el-col
          :span="24"
          style="margin-top:10px"
        >
            <el-form-item  v-if="selectdep ==2"
              label="所属企业"
              prop="qiye"
            >
              
              <el-select v-model="editshebeiFrom.qiye" placeholder="请选择">
                        <el-option
                        v-for="item in changjialist"
                        :key="item"
                        :label="item.label"
                        :value="item.id">
                        </el-option>
                    </el-select>
            </el-form-item>

            <el-form-item
              label="到期日期"
              prop="daoqi"
            >
              
               <el-date-picker
                v-model="editshebeiFrom.time"
                type="date"
                placeholder="选择日期">
    </el-date-picker>
            </el-form-item>

            <el-form-item
              label="设备名称"
              prop="DeviceName"
            >
              <el-input v-model="editshebeiFrom.DeviceName"></el-input>
            </el-form-item>

            <el-form-item
              label="设备型号"
              prop="DeviceModel"
            >
              <el-input v-model="editshebeiFrom.DeviceModel"></el-input>
            </el-form-item>

            <el-form-item
              label="设备规格"
              prop="Specs"
            >
              <el-input v-model="editshebeiFrom.Specs"></el-input>
            </el-form-item>
            <el-form-item
              label="设备位置"
              prop="Weizhi"
            >
              <el-input v-model="editshebeiFrom.Weizhi"></el-input>
            </el-form-item>
            <el-form-item
              label="负责人"
              prop="fuzeren"
            >
              <el-input v-model="editshebeiFrom.fuzeren"></el-input>
            </el-form-item>
             <el-form-item
              label="负责人手机"
              prop="fuzerentel"
            >
              <el-input v-model="editshebeiFrom.fuzerentel"></el-input>
            </el-form-item>

            <el-form-item  
              label="数据发送频率"
              prop="pinlv"
            >
              
              <el-select v-model="editshebeiFrom.pinlv" placeholder="请选择">
                        <el-option
                        v-for="item in pinlvopts"
                        :key="item"
                        :label="item.text"
                        :value="item.id">
                        </el-option>
                    </el-select>
            </el-form-item>
             
            
        </el-col>
         <el-col
          :span="24"
          style="margin-top:10px"
        >
         
        </el-col>
        </el-form>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editkongzhigFlag = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('userForm')"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
 import { provinceAndCityData} from 'element-china-area-data'
 import {getqiyetoselect,getdevicelist,editdevice,jiebang,delshebei} from '../api/api'

export default {
  data(){
    return {
      loading:false,
    keyword:'',
       qiyeid:null,
       radioval:"-1",
    defaultProps: {
          children: 'children',
          label: 'text'
        },
        
        changjialist:[],
      tabledata:[ ],
      
      editkongzhigFlag:false,
      editshebeiFrom:{
        id:'',
        qiye:null,
        fuzeren:'',
        fuzerentel:'',
        time:null,
      },
      editshebeiFromRules:{
         qiye: [
            { required: true, message: '请选择租赁企业', trigger: 'change' }
          ],
      },
      selectedOptions:null,
      options:provinceAndCityData,
      where:null,
      deps:[{id:1,text:'已关联设备'},{id:2,text:'未关联设备'}],
       selectdep:1,
       total:0,
      limit:10,
      page:1,
      pinlvopts:[{
        id:0,
        text:'关闭'
      },{
        id:1,
        text:'10分钟/次'
      },{
        id:2,
        text:'30分钟/次'
      },{
        id:3,
        text:'60分钟/次'
      },{
        id:4,
        text:'120分钟/次'
      },{
        id:5,
        text:'240分钟/次'
      }]
       
    };
  },
  computed:{
    ibHeight(){
       
      return window.innerHeight - 96;
    },
    ileftHeight(){
       
      return window.innerHeight - 126;
    },
  },
  created(){
     this.getqiyelist();
     this.query();
  },
  methods:{
    query(){
      let that = this;
      that.loading = true;
      getdevicelist({keyword:this.keyword,qiyeid:this.qiyeid,guoqitype:this.radioval,type:this.selectdep,page:this.page,limit:this.limit}).then(res=>{
        that.tabledata = res.data.list;
        that.total = res.data.count;
       setTimeout(() =>{
          that.loading = false;
        },200)
      });
    },
    handleCurrentChange(val){
      this.page = val;
      this.query();
    },
    getqiyelist(){
      let that = this;
      getqiyetoselect().then(res=>{
        that.changjialist = res.data;
      })
    },

    handleChange(){

    },
     
    submitForm(formName){

      let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
             this.editshebeiFrom.id =( this.editshebeiFrom.ddid || this.editshebeiFrom.id );
            editdevice(this.editshebeiFrom).then((res)=>{
              
               this.$message({
                message: "保存设备信息成功！",
                type: "success",
                 
              });
              that.query();
              that.editkongzhigFlag = false;
            }).catch(()=>{
              this.$message({
                message: "保存设备失败",
                type: "error"
              });
            })
             
          } else {
             
            return false;
          }
        });

     
      
    },
    editbtn(row){
     
      this.editshebeiFrom = {
        id:row.ddid,
        qiye:row.qiyeid,
        fuzeren:row.Fuzeren,
        fuzerentel:row.Fuzerentel,
        time:row.Daoqitime==" -"?'':row.Daoqitime,
        DeviceModel:row.DeviceModel,
        DeviceName:row.DeviceName,
        Specs:row.Specs,
        pinlv:row.Pinlv,
        Weizhi:row.Weizhi
      };
      this.editkongzhigFlag = true;
    },
    delbtn(row){
      let that = this;
      this.$confirm("此操作将删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {

        delshebei({id:row.ddid}).then(()=>{
this.$message({
                message: "删除设备成功",
                type: "success"
              });
that.query();
        })

         
        })
        .catch(() => {});
    },
    jiebangbtn(row){
let that = this;
      this.$confirm("此操作将解绑该设备与企业的关联, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {

        jiebang({id:row.ddid,qiyeid:row.qiyeid}).then(()=>{
this.$message({
                message: "解绑设备成功",
                type: "success"
              });
that.query();
        })

         
        })
        .catch(() => {});
    },
    changedep(opt){
        if(this.selectdep != opt.id){
            this.selectdep = opt.id;
            this.page = 1;
            this.query();
        }
    },
  }
}
</script>

<style scoped>
   
</style>
